import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { myProducts } from "./productsFunctions.js";

const initialState = {
  loading: false,
  products: [],
  error: "",
};

// Testing createAsyncThunk but myProducts is a resolved Promise already
export const fetchProducts = createAsyncThunk("products/fetchProducts", () => {
  return myProducts;
});

export const productsSlice = createSlice({
  name: "products",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchProducts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProducts.fulfilled, (state, action) => {
      state.loading = false;
      state.products = action.payload;
      state.error = "";
    });
    builder.addCase(fetchProducts.rejected, (state, action) => {
      state.loading = false;
      state.products = [];
      state.error = action.error.message;
    });
  },
});

export default productsSlice.reducer;
